// Toolbar.tsx
import React, { useEffect } from 'react';
import { useState } from "react";
import VerticalMenuBar from './VerticalMenuBar';
import SearchBar from './components/SearchBar';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';

const getBitcoin = async() =>{
  let response = await fetch('/bitcoin')
  const data = await response.json();
  console.log(data)

}
function Toolbar({color , showToolBar}) {
    const width = window.innerWidth
    const height = window.innerHeight
    const [isHovering, setIsHovering] = useState(false);
    const [isHoveringAbout, setIsHoveringAbout] = useState(false);
    const [isHoveringServices, setIsHoveringServices] = useState(false);
    const [isHoveringContact, setIsHoveringContact] = useState(false);
    const [stop, setStop] = useState(false);
    const [isSidebarCLose, setIsSidebarCLose] = useState(true);
    const navigate = useNavigate();

    useEffect(()=>{
    },[isHovering,isHoveringAbout,isHoveringServices,isHoveringContact])
    const openNav = () => {
      
      const sideBar = document.getElementById("mySidebar");
      console.log("side bar ",sideBar)
      sideBar.style.width = "250px";
      //document.getElementById("main").style.marginLeft = "250px";
    }
    const handleSideBar= () =>{
      if(isSidebarCLose){
        openNav()
        setIsSidebarCLose(false)
      }
      else{
        closeNav();
        setIsSidebarCLose(true)
      }
    }
    /* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
    const closeNav = () => {
      document.getElementById("mySidebar").style.width = "0";
      //document.getElementById("main").style.marginLeft = "0";
    }
    const handleMouseEnter = () => {
        setIsHovering(true);
   
        console.log('Mouse entered ');
      };
    
      const handleMouseLeave = () => {
        if(!stop){
          setTimeout(() =>{ setStop(false)} , 2000)
        }
        console.log('Mouse left');
      };

      const handleMouseEnterAbout = () => {
        setIsHoveringAbout(true);
    
        console.log('Mouse entered');
      };
    
      const handleMouseLeaveAbout = () => {
        if(!stop){
          setTimeout(() =>{ setStop(false)} , 2000)
        }
         // Function to call on mouse leave
        console.log('Mouse left');
      };

      const handleMouseEnterServices = () => {
        setIsHoveringServices(true);
    
        console.log('Mouse entered');
      };
    
      const handleMouseLeaveServices = () => {
        if(!stop){
          setTimeout(() =>{ setStop(false)} , 2000)
        }
      };

      const handleMouseEnterContact = () => {
        setIsHoveringContact(true);
    
        console.log('Mouse entered');
      };
    
      const handleMouseLeaveContact = () => {
        if(!stop){
          setTimeout(() =>{ setStop(false)} , 2000)
        }
        console.log('Mouse left');
      };


  return (
    <>
    <header style={{width:'100%'}}className= {`bg-${color} text-white px-4 py-3 shadow-md`}>
      <div style={{justifyContent:"space-around"}} className="flex-container relative">
        {showToolBar ?
        <div style={{paddingTop:"10px"}}> <SearchBar/></div>:
        <></>
        }
        <button className="openbtn" onClick={()=>handleSideBar()}>&#9776; Sidebar</button>
        <div style={{paddingLeft:"10px"}}className="text-xl font-bold"></div>
        <div className="flex-container relative">
          <div style={{position:"relative"}}>
          <button 
          style={{width:width/15}}
          onClick={()=>{window.location.href = "http://ec2-3-107-164-43.ap-southeast-2.compute.amazonaws.com/"}}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="buttonTool hover:bg-blue-500 px-3 py-1 rounded">
            Home
          </button>   
          {isHovering &&(
          <div style={{
            position: 'absolute',
            top: '30px',
            right: '5px',
            width: width/6,
            height: height/10,
            zIndex:10
                  }} 
            className="appear">
            <VerticalMenuBar hover={setIsHovering} setStop={setStop} msg={['Voice','SIP trunking and api']}/>
        </div>
          )}
          </div>


          <div style={{position:"relative"}}>
          <button  style={{width:width/15}} onMouseEnter={handleMouseEnterAbout}
          onMouseLeave={handleMouseLeaveAbout} 
          onClick={()=>{navigate('/trade')}}
          className="buttonTool hover:bg-blue-500 px-3 py-1 rounded">
            Trade
          </button>
          {isHoveringAbout &&(
          <div style={{
            position: 'absolute',
            top: '30px',
            right: '5px',
            width: width/6,
            height: height/10,
            zIndex:10
          }} 
          className="appear">
          <VerticalMenuBar hover={setIsHoveringAbout} setStop={setStop} msg={['Voice','SIP trunking and api']}/>
          </div>
          )}
          </div>

          <div style={{position:'relative'}}>
          <button  style={{width:width/15}}
          onMouseEnter={handleMouseEnterServices}
          onMouseLeave={handleMouseLeaveServices} 
          onClick = {()=>{getBitcoin()}}
          className="buttonTool hover:bg-blue-500 px-3 py-1 rounded">
           Services
          </button>
          {isHoveringServices &&(
            <div style={{
              position: 'absolute',
              top: '30px',
              right: '5px',
              width: width/6,
              height: height/10,
              zIndex:10
            }} 
            className="appear">
            <VerticalMenuBar hover={setIsHoveringServices} setStop={setStop} msg={['Voice','SIP trunking and api']}/>
            </div>
            )}
          </div>
          
          <div style={{position:"relative"}}>
            <button   
            style={{width:width/15}}
            onMouseEnter={handleMouseEnterContact}
            onMouseLeave={handleMouseLeaveContact} 
            onClick={()=>{navigate('/contact')}}
            className="buttonTool hover:bg-blue-500 px-3 py-1 rounded">
            Contact
            </button>
            {isHoveringContact &&(
            <div style={{
              position: 'absolute',
              top: '30px',
              right: '5px',
              width: width/6,
              height: height/10,
              zIndex:10
            }} 
            className="appear">
            <VerticalMenuBar hover={setIsHoveringContact} setStop={setStop} msg={['Email','Leonsiawl@gmail.com']}/>
            </div>
            )}
          </div>
        </div>
      </div>
    </header>
    </>
  );
};

export default Toolbar;